<template>
  <div class="item">
    <div v-if="!item">
      Item {{ iid }}  was not found
    </div>

    <v-layout v-else row wrap>
        <v-flex class="xs12 sm6 md6 lg6 xl6"  >
          <ImagePanel :item="item"></ImagePanel>
        </v-flex>

        <v-flex class="xs12 sm6 md6 lg6 xl6">
          <v-layout class="xs12 headline justify-space-betweeen">
            {{ item.name }}
            <v-spacer></v-spacer>
            <v-btn color="success" @click="editItem">Edit Item &nbsp;
              <v-icon small class="ml-1">{{$vuetify.icons.edit}}</v-icon>
            </v-btn>
          </v-layout>

          <div class="ml-4 text-xs-left subheading">
            Price: {{ formattedItemPrice }}<br />
            Quantity in stock: {{ item.quantity }}<br />
            Description: <div class="subheading ml-3" style="" v-html="item.description">

            </div>
            <span v-if="dimensionsString">Dimensions: {{ dimensionsString }}</span><br />
          </div>
        </v-flex>

        <!-- Back button -->
        <div class="text-xs-left">
          <v-btn round class="secondary" @click="$router.go(-1)">
            <v-icon small class="ml-1">{{$vuetify.icons.back}}</v-icon>
            &nbsp;Back
          </v-btn>
        </div>

    </v-layout>
</div>

</template>

<script>

import {mapState} from 'vuex'
import utils from '../../utils.ts'
import ImagePanel from '../common/ImagePanel.vue'

export default {
  name: 'Item',
  components: {
    ImagePanel
  },
  data () {
    return {
      iid: this.$route.params.iid
    }
  },
  computed: {
    ...mapState({
      items: state => state.admin.items
    }),
    item: function () {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].id === this.iid) {
          return this.items[i]
        }
      }
      return null
    },
    formattedItemPrice: function () {
      if (this.item) {
        return utils.formatCurrency(this.item.price)
      } else {
        return ''
      }
    },
    // categoryName: function () {
    //   for (const c in this.categories) {
    //     const cat = this.categories[c]
    //     if (cat.id === this.item.category) {
    //       return cat.name
    //     }
    //   }
    //   return 'Not found'
    // },
    dimensionsString: function () {
      if (this.item.dimensions && this.item.dimensions.length) {
        const d = this.item.dimensions
        const s = `${d.length}x${d.width}x${d.height} ${d.dimType}, ${d.weight} ${d.weightType}`
        return s
      } else {
        return null
      }
    }

  },
  methods: {
    editItem: function () {
      // Go to the edit item page
      this.$router.push({name: 'addedititem', params: this.item})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
